import { isNil } from 'ramda';
import { FieldArrayWithId } from 'react-hook-form';

import { findIndexFromFieldsArray } from '../utils/utils';

const useFindIndexFromFieldsArray = (
  fieldId: number | string | undefined,
  fields: FieldArrayWithId[],
  idProperty = 'id'
) => {
  if (isNil(fieldId)) {
    return 0;
  }

  return findIndexFromFieldsArray(fieldId, fields, idProperty);
};

export default useFindIndexFromFieldsArray;
